import { FC } from 'react';
import { addProtocol } from '../../../../../utils/addProtocol';
import { openExternalLink } from '../../../../../utils/openExternalLink';
import { useTranslation } from '../../../../../utils/useTranslation';
import { SiteButton } from './styles';
import { PostTextSiteLinkProps } from './types';

export const PostTextSiteLink: FC<PostTextSiteLinkProps> = ({
    post,
    text,
    onPostTextClickoutClick,
    customOnClick,
}) => {
    const { clickouts, products } = post;
    const t = useTranslation();
    const buttonText = text || t(products.businessButtonTitle) || t('Перейти на сайт');

    const clickOut = (clickouts ?? []).find((c) => c.target === 'button' && c.url);
    const clickOutUrl = clickOut?.url ? addProtocol(clickOut?.url) : undefined;

    if (!customOnClick && !clickOutUrl) {
        return null;
    }

    const handleClick = () => {
        if (customOnClick) {
            customOnClick();
        } else if (clickOutUrl) {
            openExternalLink(clickOutUrl);
        }
        onPostTextClickoutClick?.();
    };

    return (
        <SiteButton color={'primary'} onClick={handleClick}>
            {buttonText}
        </SiteButton>
    );
};
